/** 값 없음 표시 — 모든 화면에서 null · undefined · 빈 문자열은 '-' 로 보인다 */
export const EMPTY_VALUE = '-';

/** null · undefined · 공백뿐인 문자열이면 '-' */
export const orDash = (value: string | number | null | undefined) =>
  value == null || String(value).trim() === '' ? EMPTY_VALUE : value;

/** 숫자 + 단위 (1234, '건' → '1,234건') */
export const formatCount = (value: number, unit = '') =>
  `${value.toLocaleString('ko-KR')}${unit}`;

/** '2026-08-31' → '2026.08.31' */
export const formatDate = (date: string) => date.replace(/-/g, '.');

/** '2026-08-31' → '08.31' */
export const formatMonthDay = (date: string) => date.slice(5).replace('-', '.');

/** '경기도 수원시 영통구' → '수원시 영통구' (07 지역 칸은 시/군/구만). 없으면 '-' */
export const toSigungu = (region: string | null | undefined) => {
  if (region == null || region.trim() === '') return EMPTY_VALUE;
  const [, ...rest] = region.split(' ');
  return rest.length > 0 ? rest.join(' ') : region;
};
